import { Flex, InputLabel, Paper, Radio, Title } from "@mantine/core";
import React from "react";

interface TextModeSelectorProps {
  isNumber: boolean;
  onChange: (value: string) => void;
  t: (key: string) => string;
  px?: string;
}

const TextModeSelector: React.FC<TextModeSelectorProps> = ({
  isNumber,
  onChange,
  t,
  px,
}) => (
  <Paper px={px}>
    <Title mb={6} order={4}>
      {t("scheme.redactor.panelOptions.setText.title")}
    </Title>
    <InputLabel>
      {t("scheme.redactor.panelOptions.setText.selectMode")}
    </InputLabel>
    <Radio.Group
      value={isNumber ? "number" : "word"}
      onChange={onChange}
      py={10}
    >
      <Flex gap={10}>
        <Radio
          value="number"
          label={t("scheme.redactor.panelOptions.setText.numberMode")}
        />
        <Radio
          value="word"
          label={t("scheme.redactor.panelOptions.setText.wordMode")}
        />
      </Flex>
    </Radio.Group>
  </Paper>
);

export default React.memo(TextModeSelector);
